import { Injectable } from '@angular/core';
import { DiscountModel } from './model/discount.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  constructor(private http: HttpClient) { }

  getDiscountList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/discount/get', requestData);
  }

  getDiscountById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/discount/get/' + id, '');
  }

  update(discountInfo: DiscountModel): Observable<any> {
    if (discountInfo.hasOwnProperty("id")) {
      return this.http.post(environment.baseUrl + '/discount/update', discountInfo);
    } else {
      return this.http.post(environment.baseUrl + '/discount/add', discountInfo);
    }
  }

  delete(discountInfo: DiscountModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/discount/delete/' + discountInfo.id, discountInfo);
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post(environment.baseUrl + '/discount/export-discount-list', requestData, { headers, responseType: 'blob' });
  }


  deleteSaleItemDiscount(discountId: number, saleItemId: number): Observable<any> {
    // Set query parameters
    const params = new HttpParams()
      .set('discountId', discountId.toString())
      .set('saleItemId', saleItemId.toString());

    // Make DELETE request with parameters
    return this.http.delete(
      environment.baseUrl + '/discount/delete-sale-item',
      { params: params }
    );
  }
}
